import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').constant('USER_AUTH_FLAG', 'USER_AUTH_FLAG');
})();
